import { render, staticRenderFns } from "./AmountCYSelectOldPage.vue?vue&type=template&id=166f8f98&scoped=true"
import script from "./AmountCYSelectOldPage.vue?vue&type=script&lang=js"
export * from "./AmountCYSelectOldPage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYSelectOldPage.vue?vue&type=style&index=0&id=166f8f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f8f98",
  null
  
)

export default component.exports